<script setup>

// Props
const props = defineProps({
  messages: {
    type: Array,
    default: () => []
  }
});

</script>

<template>
  <div class="modal com_modal2 fade" id="apiErrorModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
        <div class="error-messages">
          <div v-for="(message, index) in props.messages" :key="index" class="error-message">
            {{ message }}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn com_btn2 wd1" data-bs-dismiss="modal">閉じる</button>
      </div>
    </div>
    </div>
  </div>
</template>

<style scoped>
.error-messages {
  margin: 0;
}

.error-message {
  margin-bottom: 1rem;
  font-size: 1rem;
  color: #333;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
  white-space: pre-wrap;
  word-break: break-word;
}

.error-message:not(:first-child) {
  font-size: 0.75rem;
  text-align: left;
  color: #666;
  margin-bottom: 0.25rem;
  padding: 0.15rem 0;
  border-bottom: none;
}

.error-message:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

</style>
